import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";
// THIS WOULD BE NORMALLY THE END OF SCENARIO4part3, BUT THE BADGING WAS TRICKY SO THIS WAS EXTRACTED AND MADE INTO ITS OWN PART

export default class Scenario4Part15 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 3;
	chapterIds = {
		scenario4_3a_s7: 'CALM - Scenario 4 - 3A - Segment 7',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part15.id;
	}

	public start() {
		const context = this;
		context.segment6Step1GoToRestaffing();
	}


	private segment6Step1GoToRestaffing() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.showStaffingPlanUI(() => {
			context.segment7Step1RestaffingQuiz();
		});			
		context.scenario.updateObjective('How many patients does your staff have?');
	}

	private segment7Step1RestaffingQuiz() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('')
		context.playVideoChapter(context.chapterIds.scenario4_3a_s7, () => {
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
				title: 'Given that Marco and Miranda each have four patients while Ben has five patients, which is the best option to re-staff Heather’s remaining three patients?',
				options: [
					{
						text: 'Give Marco, Ben, and Miranda each an additional patient.',
						isCorrect: false,
						scoreType: ScoreType.Zero,
						feedback: 'While this seems fair and plausible, Marco has a patient in isolation, which is an extra burden. It may not be good to give him another patient. '
					},
					{
						text: 'Give Ben and Miranda each two additional patients.',
						isCorrect: false,
						scoreType: ScoreType.Zero,
						feedback: 'Ben already has 5 patients. Two more could put all of his patients at risk. There are alternative options.'
					},
					{
						text: 'Give Ben one additional patient and Miranda two additional patients.',
						isCorrect: false,
						scoreType: ScoreType.Zero,
						feedback: 'While Ben, an experienced RN, could handle one more patient temporarily, Miranda is inexperienced and handling six patients could be a challenge. It also puts her patients at risk. We have already seen that Miranda needs extra support and lacks confidence in some areas such as blood transfusions. Furthermore, all of Miranda’s current patients are in the opposite area of the unit from Heather’s patients.'
					},
					{
						text: 'Give Ben, Miranda, and yourself one additional patient.',
						isCorrect: true,
						scoreType: ScoreType.Best,
						feedback: 'This is the most viable option. RN Marco has a patient in isolation, so taking another patient could be a burden. While Ben and Miranda can handle one more patient, you may be able to take one patient temporarily using LPN Jamie as your support person. It would be good to also give Miranda the lowest acuity patient since Miranda currently spends her time furthest from Heather’s patients and may not be within earshot distance of the patient. She also seems to have low confidence, so overwhelming her could put patient care at risk.'
					}
				],
				onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
					context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx) 
				},
				onClosed: (config: NurseStationComputerSingleQustionUIConfig) => { // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
					context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
					context.segment2Step1Reports();
				},
			})
		});
		context.scenario.updateObjective('');
	}

	private segment2Step1Reports() {
		var context = this;
		context.scenario.updateObjective('');		
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
				reports: [
					{
						title: 'Incident',
						description: 'Nothing to add to report.'
					},
					{
						title: '24 Hour',
						description: 'Nothing to add to report.'
					},
					{
						title: 'End of Shift',
						description: 'Nothing to add to report.'
					}
				],
				review: {
					text:
						`
						<p class="regular-description-font" style="margin: 0;">
							Re-staffing patients in a unit is a very dynamic process as patients are constantly being discharged, moved, 
							and admitted. <br /><br />
							As such, a Charge Nurse is continuously challenged to <span style="color: rgb(222, 225, 156)"> balance staff 
							experience with patient needs and patient acuity </span> while at the same time attempting to <span style="color: rgb(222, 225, 156)">
							keep staff patients in the same area of the unit so their patients are nearby. </span> <br /><br />
							Additionally, staff have personal considerations such as staff could be on <span style="color: rgb(222, 225, 156)"> light duty, 
							can’t sit for long periods, or have spent the last three shifts on patient observation </span> and need a break. <br /><br />
							Furthermore, you should be <span style="color: rgb(222, 225, 156)"> mindful of patient diagnoses and isolation status when re-staffing. 
							</span> Each time re-staffing is accomplished, <span style="color: rgb(222, 225, 156)"> it must be communicated to staff and noted 
							so all staff are cognizant of everyone’s responsibilities. </span> <br /><br />
						</p>
						`
				},
				reflects: [
					{
						title: 'How do you re-staff your unit when need be?',
						answer: ''
					},
					{
						title: 'What factors do you consider when you have to re-staff?',
						answer: ''
					},
					{
						title: 'What staff conditions do you commonly account for in re-staffing?',
						answer: ''
					},
					{
						title: 'How do you track staffing assignments?',
						answer: ''
					},
					{
						title: 'How do you communicate re-staffing changes to your staff?',
						answer: ''
					},
					{
						title: 'How do you handle staff reluctant to take on some patients, such as high acuity patients?',
						answer: ''
					}
				],
				onClosed: (config: NurseStationComputerUIConfig) => {
					context.scenario.update508Window(Window508Type.Main);
					context.segment9Badge();
				}
			})
	}

	private segment9Badge() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx] + this.scenario.staffingPlanScore;

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {				
			context.onDone();
		});
	}
}